import { gql } from '@apollo/client';

export default gql`
  query GetStudentMediaItemStats(
    $courseId: String!
    $studentId: String!
    $mediaId: String!
  ) {
    mediaStats(courseId: $courseId, studentId: $studentId, mediaId: $mediaId)
      @rest(
        type: "StudentMediaStatsPayload"
        path: "courses/{args.courseId}/students/{args.studentId}/media-stats/{args.mediaId}"
      ) {
      totalViews
      avgProgressPercentage
      maxProgressPercentage
      student {
        _id
        name
        email
      }
      media {
        _id
        name
      }
      sessions {
        progressPercentage
        platform
        createdAt
        lastEventDate
        skipProgress
      }
    }
  }
`;
